import { createFileRoute } from '@tanstack/react-router';

import { NeedsAttentionProductsPage } from '~/features/catalog-operations/pages/needs-attention-products-page';
import { RequireChannelConnection } from '~/features/onboarding/components/require-channel-connection';

export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-operations/products-need-attention',
)({
  component: () => (
    <RequireChannelConnection>
      <NeedsAttentionProductsPage />
    </RequireChannelConnection>
  ),
});
